import { memo, useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import CustomButton from "../component/button";
import { json, useNavigate } from "react-router-dom";
import { toastMsg } from "../component/toast";
import { AppContext } from "../context/AppContext";
import { ApiConfig } from "../Api/ApiConfig";
import { PostCallWithErrorResponse } from "../Api/ApiServices";

const MessageBox = memo((props) => {

    const { adminData } = useContext(AppContext)

    const { message, setIsOpen, isOpen } = props


    return (
        <>
            <Modal show={isOpen}
                onHide={() => setIsOpen(false)}
                centered
                size="md">
                <Modal.Body>
                    {
                        props.children
                    }
                </Modal.Body>
            </Modal>
        </>
    )

})

export default MessageBox